import dayjs from "dayjs";

const fields = [
  {
    type: "bsx-input",
    inputType: "text",
    label: "系統",
    model: "platform",
    required: true,
    readonly: true,    
  },
  {
    type: "bsx-input",
    inputType: "text",
    label: "版本",    
    model: "version",
    placeholder: "請輸入版本",
    labelRemark: '請輸入符合版號格式 (如：1.1.933) ',
    required: true,
    validator: function () {
      this.validation();
    },
  },  
  {
    type: 'bsx-toggle',
    label: '是否啟用',
    model: 'status',
    required: true,
    textOn: '啟用',
    textOff: '停用',
    valueOn: 'ON',
    valueOff: 'OFF',
  },
];

export default fields;
